import { getData } from '../utils/data.js';
export const ClientMemberStatus = {
    Joined: 'joined',
    Retired: 'retired',
};
export const ClientMemberRole = {
    Member: 'member',
    Admin: 'admin',
};
export const ClientMemberNotificationMethod = {
    Email: 'email',
    Line: 'line',
};
export const clientMemberConverter = {
    fromFirestore(snap, op) {
        return getData(snap, op);
    },
    toFirestore(d) {
        return d;
    },
};
export const createClientMemberFromInput = (input) => {
    const now = new Date();
    return {
        notificationMethods: [ClientMemberNotificationMethod.Email],
        createdAt: now,
        updatedAt: now,
        ...input,
    };
};
export const createClientMemberFromAuthUser = (user, role) => {
    const now = new Date();
    return {
        name: user.displayName ?? user.email ?? '',
        email: user.email ?? '',
        phone: user.phoneNumber ?? '',
        iconURL: user.photoURL ?? '',
        status: ClientMemberStatus.Joined,
        role: role,
        notificationMethods: [ClientMemberNotificationMethod.Email],
        createdAt: now,
        updatedAt: now,
    };
};
//# sourceMappingURL=clientMember.js.map